
<template>
  <div>
    <v-dialog v-model="dialog" max-width="650px" scrollable transition="dialog-transition" >
      <template v-slot:activator="{on}">

        <v-tooltip v-on='on' top color='black'>
          <template v-slot:activator="{on}">
            <v-btn icon v-on="on" @click='dialog= true' small color="white"w class="primary" >
              <v-icon small>mdi-calculator</v-icon> 
            </v-btn>
          </template>
          Ver consolidação
          
        </v-tooltip>

      </template>
      <v-card v-if='dialog' style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Consolidação do cliente</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-alert v-if='loading' type="info" :value="true">
            Carregando...
            <v-progress-linear color="white" :indeterminate="true"></v-progress-linear>
          </v-alert>
          <template v-if='!loading'>
            <div> <b> {{consolidation.client_name}} </b></div>
            
            <v-subheader>Resumo financeiro</v-subheader>
            <v-row class='px-3 my-2 grey lighten-3 py-2'>
              <v-col cols='1'>
                <span class="red--text">TD</span>
              </v-col>
              <v-col cols='7' text-xs-left>
                Todas as despesas do cliente
              </v-col>
              <v-col cols='4' >
                {{Number(consolidation.all_out).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}
              </v-col>
            </v-row>
            <v-row class='px-3 my-2'>
              <v-col cols='1'>
                <span class="red--text">TV</span>
              </v-col>
              <v-col cols='7' text-xs-left>
                Todas as vendas
              </v-col>
              <v-col cols='4' >
                {{Number(consolidation.orders).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}
              </v-col>
            </v-row>

            <v-row class='px-3 my-2 grey lighten-3 py-2'>
              <v-col cols='1'>
                <span class="red--text">TP</span>
              </v-col>
              <v-col cols='7' text-xs-left>
                Todos os pagamentos
              </v-col>
              <v-col cols='4' >
                {{Number(consolidation.all_payed).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}
              </v-col>
            </v-row>

            <v-row class='px-3 my-2'>
              <v-col cols='1'>
                <span class="red--text">TF</span>
              </v-col>
              <v-col cols='7' text-xs-left>
                Todos as faturas
              </v-col>
              <v-col cols='4' >
                {{Number(consolidation.all_vrt_transactions).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}
              </v-col>
            </v-row>
            <v-row class='px-3 my-2 grey lighten-3 py-2'>
              <v-col cols='1'>
                <span class="red--text">TFP</span>
              </v-col>
              <v-col cols='7' text-xs-left>
                Todos as faturas com pagamentos
              </v-col>
              <v-col cols='4' >
                {{Number(consolidation.all_vrt_trans_with_payment).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}
              </v-col>
            </v-row>
            <v-row class='px-3 my-2'>
              <v-col cols='1'>
                <span class="red--text">TFA</span>
              </v-col>
              <v-col cols='7' text-xs-left>
                Todos as faturas abertas
              </v-col>
              <v-col cols='4' >
                {{Number(consolidation.all_vrt_transactions - consolidation.all_vrt_trans_with_payment).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}
              </v-col>
            </v-row>

            <v-row class='px-3 my-2 grey lighten-3 py-2'>
              <v-col cols='1'>
                <span class="red--text">TE</span>
              </v-col>
              <v-col cols='7' text-xs-left>
                Todos os estornos
              </v-col>
              <v-col cols='4' >
                {{Number(consolidation.reversals).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}
              </v-col>
            </v-row>

            <v-divider></v-divider>
            <v-subheader>Crédito</v-subheader>
            

            <v-row class='px-3 my-2'>
              <v-col cols='1'>
                <span class="red--text">LA</span>
              </v-col>
              <v-col cols='7' text-xs-left>
                Limite atual
              </v-col>
              <v-col cols='4' >
                {{Number(consolidation.payload.client_credit.limit).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}
              </v-col>
            </v-row>
            <v-row class='px-3 my-2 grey lighten-3 py-2'>
              <v-col cols='1'>
                <span class="red--text">LO</span>
              </v-col>
              <v-col cols='7' text-xs-left>
                Limite original
              </v-col>
              <v-col cols='4' >
                {{Number(consolidation.payload.client_credit.original_limit).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}
              </v-col>
            </v-row>
            <v-row class='px-3 my-2'>
              <v-col cols='1'>
                <span class="red--text">BO</span>
              </v-col>
              <v-col cols='7' text-xs-left>
                Bonus
              </v-col>
              <v-col cols='4' >
                {{Number(consolidation.payload.client_credit.bonus).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}
              </v-col>
            </v-row>

            <v-divider></v-divider>
            <v-subheader>Valores</v-subheader>
            
            <v-row class='px-3 my-2 grey lighten-3 py-2'>
              <v-col cols='1'>
                <span class="red--text">BA</span>
              </v-col>
              <v-col cols='7' text-xs-left>
                Boletos em aberto
              </v-col>
              <v-col cols='4' >
                {{Number(consolidation.payload.val.BA).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}
              </v-col>
            </v-row>
            <v-row class='px-3 my-2'>
              <v-col cols='1'>
                <span class="red--text">BP</span>
              </v-col>
              <v-col cols='7' text-xs-left>
                Boletos pagos
              </v-col>
              <v-col cols='4' >
                {{Number(consolidation.payload.val.BP).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}
              </v-col>
            </v-row>
            <v-row class='px-3 my-2 grey lighten-3 py-2'>
              <v-col cols='1'>
                <span class="red--text">FA</span>
              </v-col>
              <v-col cols='7' text-xs-left>
                Faturas em aberto
              </v-col>
              <v-col cols='4' >
                {{Number(consolidation.payload.val.FA).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}
              </v-col>
            </v-row>
            <v-row class='px-3 my-2'>
              <v-col cols='1'>
                <span class="red--text">FP</span>
              </v-col>
              <v-col cols='7' text-xs-left>
                Faturas pagas
              </v-col>
              <v-col cols='4' >
                {{Number(consolidation.payload.val.FP).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}
              </v-col>
            </v-row>


            <v-divider></v-divider>
            <v-subheader>Operações</v-subheader>
            
            <v-row class='px-3 my-2 grey lighten-3 py-2'>
              <v-col cols='7' text-xs-left>
                <span class="font-weight-bold mr-1">Operação 1: </span> {{consolidation.payload.ops.op1}}
              </v-col>
              <v-col cols='5' >
                <span>{{Number(consolidation.payload.ops.op1_left).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}</span> 
                = 
                <span>{{Number(consolidation.payload.ops.op1_right).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}</span>
              </v-col>
            </v-row>
            <v-row class='px-3 my-2'>
              <v-col cols='7' text-xs-left>
                <span class="font-weight-bold mr-1">Operação 2: </span> {{consolidation.payload.ops.op2}}
              </v-col>
              <v-col cols='5' >
                <span>{{Number(consolidation.payload.ops.op2_left).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}</span> 
                = 
                <span>{{Number(consolidation.payload.ops.op2_right).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}</span>
              </v-col>
            </v-row>
            <v-row class='px-3 my-2 grey lighten-3 py-2'>
              <v-col cols='7' text-xs-left>
                <span class="font-weight-bold mr-1">Operação 3: </span> {{consolidation.payload.ops.op3}}
              </v-col>
              <v-col cols='5' >
                <span>{{Number(consolidation.payload.ops.op3_left).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}</span> 
                = 
                <span>{{Number(consolidation.payload.ops.op3_right).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}</span>
              </v-col>
            </v-row>
            <v-row class='px-3 my-2'>
              <v-col cols='7' text-xs-left>
                <span class="font-weight-bold mr-1">Operação 4: </span> {{consolidation.payload.ops.op4}}
              </v-col>
              <v-col cols='5' >
                <span>{{Number(consolidation.payload.ops.op4_left).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}</span> 
                = 
                <span>{{Number(consolidation.payload.ops.op4_right).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}</span>
              </v-col>
            </v-row>
            <v-row class='px-3 my-2 grey lighten-3 py-2'>
              <v-col cols='7' text-xs-left>
                <span class="font-weight-bold mr-1">Operação 5: </span> {{consolidation.payload.ops.op5}}
              </v-col>
              <v-col cols='5' >
                <span>{{Number(consolidation.payload.ops.op5_left).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}</span> 
                = 
                <span>{{Number(consolidation.payload.ops.op5_right).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}</span>
              </v-col>
            </v-row>
            <v-row class='px-3 my-2'>
              <v-col cols='7' text-xs-left>
                <span class="font-weight-bold mr-1">Operação 6: </span> {{consolidation.payload.ops.op6}}
              </v-col>
              <v-col cols='5' >
                <span>{{Number(consolidation.payload.ops.op6_left).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}</span> 
                = 
                <span>{{Number(consolidation.payload.ops.op6_right).toLocaleString('pt-BR',{style:'currency', currency: 'BRL'})}}</span>
              </v-col>
            </v-row>

            <!-- other_vrt_transactions      : outras_faturas,
            reversals                   : estornos,
            orders                      : orders,
            all_out                     : tudo_que_saiu,
            all_payed                   : tudo_que_pagou,
            all_payed_open              : tudo_que_pagou_e_aberto,
            all_payed_done              : tudo_que_pagou_e_concluido,
            all_vrt_transactions        : todas_vrts_somadas,
            all_vrt_trans_with_payment  : todas_vrts_com_pagamento, -->

            
            <v-divider></v-divider>

            <v-subheader>Comentários</v-subheader>
            <div>{{consolidation.comments}}</div>
            
          </template>
        </v-card-text>
        <v-card-actions class="justify-end" v-if='false'>
          <f-btn cancel color="error"></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index';

export default {
  name: 'ClientFinancialConsolidation',
  props: {
    client_id: {
      type: [Number, String],
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      consolidation: {},
    }
  },
  methods: {
    getFinancialConsolidation(){
      this.loading = true
      this.consolidation = {}
      Api.Client.showConsolidation(this.client_id).then(r=>r.data).then(r=>{
        r = r.length? r[0] : r
        this.consolidation = {...r}
      }).catch(err=> {
        console.log(err);
      }).finally(()=>{
        this.loading = false
      })
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    dialog(nv,ov) {
      if (nv){
        this.getFinancialConsolidation()
      } else if (nv == false){
        this.consolidation = {}
      }
    }
  },
}
</script>

<style scoped>

</style>